import React from 'react';
import './DeleteButton.css';

interface DeleteButtonProps {
  /** Text to display in red letters */
  label: string;
  /** Callback fired when button is clicked */
  onClick?: () => void;
  /** Disable the button */
  disabled?: boolean;
  /** Additional CSS class name */
  className?: string;
}

function DeleteButton({
  label,
  onClick,
  disabled = false,
  className = '',
}: DeleteButtonProps) {
  return (
    <button
      type="button"
      className={`delete-button ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="delete-button__text">{label}</span>
    </button>
  );
}

export default DeleteButton;

